export const getDescriptor = (filterTypes, key) =>
  filterTypes.find(filter => filter.key === key);

export const isDefaultValue = record => Boolean(record.isEmpty);
